import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import AccordionComponent from "../../../../common/Accordion";
import {
  PICKLIST_GROUP_NAME,
  STAKEHOLDER_TYPE,
  WEB_ROLE,
} from "../../../../common/Constant";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import {
  addUser,
  fetchCompanyIDList,
  fetchDepartmenteBaseOnWebRole,
  fetchPickListByGroupName,
  fetchUserTypeBaseOnWebRole,
  updateUser,
  validateUserPrefix,
} from "../../../../services/UserRegistrationApi";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import TextInput from "../../../../common/TextInput";
import TextInputTypeField from "../../../../common/TextInputTypeField";
import FormattedPhoneInput from "../../../../common/FormattedPhoneInput";
import SearchableMultiSelectDropdown from "../../../../common/SearchableMultiSelectDropdown";
import Snackbar from "../../../../common/Snackbar";
import { validateContactUser } from "./stakeholderValidation";
import { last } from "pdf-lib";

interface UserProps {
  StakeholderLabel: string;
  setNewContactID: any;
  onBack: () => void;
  selectedUserRoleLabel: string;
}

const currencyData = [
  {
    label: "USD",
    value: "USD",
  },
  {
    label: "INR",
    value: "INR",
  },
];

const AddNewContactUser: React.FC<UserProps> = ({
  StakeholderLabel,
  setNewContactID,
  onBack,
  selectedUserRoleLabel,
}) => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [saluationOption, setSaluationOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [genderOption, setGenderOption] = useState<
    { value: string; label: string }[]
  >([]);

  const [companyIDOptions, setCompanyIDOptions] = useState<any[]>([]);
  const [webRoleOptions, setWebRoleOptions] = useState<any[]>([]);
  const [departmentOptions, setDepartmentOptions] = useState<any[]>([]);
  const [userTypeOptions, setUserTypeOptions] = useState<any[]>([]);
  const [currencyOptions, setCurrencyOptions] = useState<any[]>(currencyData);
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const [saluation, setSaluation] = useState<string | number | null>(null);
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [userPrefix, setUserPrefix] = useState("");
  const [gender, setGender] = useState<string | number | null>(null);
  const [emailId, setEmailId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [faxNumber, setFaxNumber] = useState("");
  const [companyID, setCompanyID] = useState<string | number | null>(null);
  const [webRoleID, setWebRoleID] = useState<(any | null)[]>([]);
  const [departmentID, setDepartmentID] = useState<string | number | null>(
    null,
  );
  const [userTypeID, setUserTypeID] = useState<string | number | null>(null);
  const [isActive, setIsActive] = useState<boolean>(true);
  const [isMFA, setIsMFA] = useState<boolean>(true);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [userID, setUserID] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [isShortCodeValid, setIsShortCodeValid] = useState<boolean | null>(
    null,
  );
  const [processedWebRoleOptions, setProcessedWebRoleOptions] = useState<any[]>(
    [],
  );

  const params = {
    salutation: {
      groupName: PICKLIST_GROUP_NAME.Salutation_Type,
      triggerById: loggedInUserid,
    },
    gender: {
      groupName: PICKLIST_GROUP_NAME.Gender,
      triggerById: loggedInUserid,
    },
    webRole: {
      groupName: PICKLIST_GROUP_NAME.Web_Application_Role,
      triggerById: loggedInUserid,
    },
    userType: {
      groupName: PICKLIST_GROUP_NAME.User_Types,
      triggerById: loggedInUserid,
    },
    department: {
      groupName: PICKLIST_GROUP_NAME.Organization_Departments,
      triggerById: loggedInUserid,
    },
  };

  const fetchUserPicklistData = async () => {
    try {
      const salutationData = await fetchPickListByGroupName(params.salutation);
      const genderData = await fetchPickListByGroupName(params.gender);
      const companyData = await fetchCompanyIDList();
      const webRoleData = await fetchPickListByGroupName(params.webRole);
      const departmentData = await fetchPickListByGroupName(params.department);
      const userTypeData = await fetchPickListByGroupName(params.userType);

      setSaluationOption(salutationData || []);
      setGenderOption(genderData || []);
      setCompanyIDOptions(companyData);

      setWebRoleOptions(webRoleData || []);

      setUserTypeOptions(userTypeData || []);
      setDepartmentOptions(departmentData || []);

      if (companyData && companyData.length > 0) {
        setCompanyID(companyData[0].value);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchUserPicklistData();
  }, []);

  useEffect(() => {
    if (webRoleOptions.length === 0) return;

    // Define a mapping from StakeholderLabel and selectedUserRoleLabel to WEB_ROLE labels
    const stakeholderToRoleMap: Record<string, string> = {
      [STAKEHOLDER_TYPE.QME_Doctor]: WEB_ROLE.QME_Doctor,
      [STAKEHOLDER_TYPE.Applicant_Attorney]: WEB_ROLE.Applicant_Attorney,
      [STAKEHOLDER_TYPE.Défense_Attorney]: WEB_ROLE.Defense_Attorney,
      [STAKEHOLDER_TYPE.Insurance]: WEB_ROLE.Claims_Administrator,
      [STAKEHOLDER_TYPE.Patient]: WEB_ROLE.Injured_Worker,
    };

    const userRoleLabels = [
      WEB_ROLE.QME_Doctor,
      WEB_ROLE.Editor,
      WEB_ROLE.Scheduler,
      WEB_ROLE.Case_Manager,
      WEB_ROLE.Historian,
      WEB_ROLE.Billing_Specialist,
      WEB_ROLE.Transcriber,
      WEB_ROLE.Medical_Assistant,
    ];

    // Determine the role label based on StakeholderLabel or selectedUserRoleLabel
    const targetLabel =
      stakeholderToRoleMap[StakeholderLabel] || // from stakeholder
      (userRoleLabels.includes(selectedUserRoleLabel)
        ? selectedUserRoleLabel
        : null); // from user role

    if (targetLabel) {
      const matchedRole = webRoleOptions.find(
        (role) => role.label === targetLabel,
      );
      if (matchedRole) {
        setWebRoleID([matchedRole.value]);
      }
    }
  }, [StakeholderLabel, selectedUserRoleLabel, webRoleOptions]);

  useEffect(() => {
    const specialRoles = ["System Admin", "App Admin"];

    const selectedRoles = webRoleOptions.filter((role) =>
      webRoleID?.includes(role.value),
    );

    const selectedLabels = selectedRoles.map((role) => role.label);

    const isOnlySystemAdminSelected =
      selectedLabels.length === 1 && selectedLabels[0] === "System Admin";
    const isOnlyAppAdminSelected =
      selectedLabels.length === 1 && selectedLabels[0] === "App Admin";

    const hasNonAdminSelected = selectedLabels.some(
      (label) => !specialRoles.includes(label),
    );

    const updatedOptions = webRoleOptions.map((role) => {
      const isSpecial = specialRoles.includes(role.label);

      if (isOnlySystemAdminSelected) {
        return { ...role, disabled: role.label !== "System Admin" };
      }

      if (isOnlyAppAdminSelected) {
        return { ...role, disabled: role.label !== "App Admin" };
      }

      if (hasNonAdminSelected && isSpecial) {
        return { ...role, disabled: true };
      }

      return { ...role, disabled: false };
    });

    setProcessedWebRoleOptions(updatedOptions);
  }, [webRoleID, webRoleOptions]);

  const handleCurrencyChange = (e: any) => {
    const selectedValue = e.target.value;

    const selectedOption = currencyOptions.find(
      (opt) => String(opt.value) === String(selectedValue),
    );

    setSelectedCurrency(selectedValue);
  };

  React.useEffect(() => {
    const fetchDependentDropdowns = async () => {
      if (webRoleID && loggedInUserid) {
        try {
          const departmentData = await fetchDepartmenteBaseOnWebRole(
            webRoleID,
            loggedInUserid,
          );
          const userTypeData = await fetchUserTypeBaseOnWebRole(
            webRoleID,
            loggedInUserid,
          );

          setDepartmentOptions(departmentData || []);
          setUserTypeOptions(userTypeData || []);
        } catch (error) {
          console.error("Error fetching dependent dropdowns:", error);
        }
      }
    };

    // Reset department and user type when webRoleID changes
    setDepartmentID(null);
    setUserTypeID(null);
    setDepartmentOptions([]);
    setUserTypeOptions([]);

    fetchDependentDropdowns();
  }, [webRoleID, loggedInUserid, StakeholderLabel]); // Include StakeholderLabel as a dependency

  useEffect(() => {
    if (!webRoleID || webRoleID.length !== 1) return;

    const singleRole = webRoleOptions.find(
      (role) => role.value === webRoleID[0],
    );
    if (!singleRole) return;

    switch (singleRole.label) {
      case WEB_ROLE.QME_Doctor:
      case WEB_ROLE.Scheduler:
        setDepartmentID(
          departmentOptions.find((d) => d.label === "Customer Service")
            ?.value || null,
        );
        setUserTypeID(
          userTypeOptions.find((u) => u.label === "External - PMC")?.value ||
            null,
        );
        break;

      case WEB_ROLE.Case_Manager:
      case WEB_ROLE.Transcriber:
      case WEB_ROLE.Historian:
      case WEB_ROLE.Record_Reviewer:
      case WEB_ROLE.Medical_Assistant:
      case WEB_ROLE.Supervisor:
        setDepartmentID(
          departmentOptions.find((d) => d.label === "Account Management")
            ?.value || null,
        );
        setUserTypeID(
          userTypeOptions.find((u) => u.label === "External - PMC")?.value ||
            null,
        );
        break;

      case WEB_ROLE.Billing_Specialist:
        setDepartmentID(
          departmentOptions.find((d) => d.label === "Finance")?.value || null,
        );
        setUserTypeID(
          userTypeOptions.find((u) => u.label === "External - PMC")?.value ||
            null,
        );
        break;

      case WEB_ROLE.Editor:
        setDepartmentID(
          departmentOptions.find((d) => d.label === "Editor")?.value || null,
        );
        setUserTypeID(
          userTypeOptions.find((u) => u.label === "External - PMC")?.value ||
            null,
        );
        break;
      case WEB_ROLE.Practice_Manager:
        setUserTypeID(
          userTypeOptions.find((u) => u.label === "External - PMC")?.value ||
            null,
        );
        break;

      case WEB_ROLE.IndependentQMEDoctor:
        setUserTypeID(
          userTypeOptions.find(
            (u) => u.label === "External - Independent QME Doctor",
          )?.value || null,
        );
        break;

      case WEB_ROLE.Claims_Administrator:
        setDepartmentID(
          departmentOptions.find((d) => d.label === "Account Management")
            ?.value || null,
        );
        setUserTypeID(
          userTypeOptions.find(
            (u) => u.label === "External - Insurance (Claims)",
          )?.value || null,
        );
        break;

      case WEB_ROLE.Claims_Administrator:
        setDepartmentID(
          departmentOptions.find((d) => d.label === "Account Management")
            ?.value || null,
        );
        setUserTypeID(
          userTypeOptions.find(
            (u) => u.label === "External - Insurance (Claims)",
          )?.value || null,
        );
        break;

      case WEB_ROLE.Applicant_Attorney:
      case WEB_ROLE.Defense_Attorney:
        setDepartmentID(
          departmentOptions.find((d) => d.label === "Account Management")
            ?.value || null,
        );
        setUserTypeID(
          userTypeOptions.find((u) => u.label === "External - Attorney(s)")
            ?.value || null,
        );
        break;

      case WEB_ROLE.Injured_Worker:
        setDepartmentID(
          departmentOptions.find((d) => d.label === "Account Management")
            ?.value || null,
        );
        setUserTypeID(
          userTypeOptions.find((u) => u.label === "Injured Worker")?.value ||
            null,
        );
        break;

      default:
        // No changes for other roles
        break;
    }
  }, [webRoleID, webRoleOptions, departmentOptions, userTypeOptions]);

  const validateContactUserForm = () => {
    // Prepare values to pass for validation
    const validationErrors = validateContactUser(
      saluation,
      firstName,
      userName,
      gender,
      emailId,
      phoneNumber,
      faxNumber,
      webRoleID,
      departmentID,
      userTypeID,
      StakeholderLabel,
      userTypeOptions, // Pass the options here
    );

    // Call the validation function

    if (validationErrors.length > 0) {
      setSnackbarMessage(validationErrors.join("\n")); // Show error messages directly
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const handleSave = async () => {
    if (isSaving) return;
    if (validateContactUserForm()) {
      try {
        setIsSaving(true);
        const userData = {
          salutationtypeid: saluation ? saluation : null,
          firstname: firstName ? firstName : null,
          middlename: middleName ? middleName : "",
          lastname: lastName ? lastName : "",
          username: userName ? userName : null,
          counterSign: password,
          UserPrefix: userPrefix,
          //genderid: gender ? gender : null,
          emailid: emailId ? emailId : null,
          phonenumber: phoneNumber ? phoneNumber : null,
          faxnumber: faxNumber ? faxNumber : "",
          companyid: companyID ? companyID : null,
          roleids: webRoleID && webRoleID.length > 0 ? webRoleID : null,
          departmentid: departmentID ? departmentID : null,
          usertypeid: userTypeID ? userTypeID : null,
          isactive: isActive ? 1 : 0,
          ismfa: isMFA ? 1 : 0,
          LoggedInUserid: loggedInUserid,
          currencyType: selectedCurrency,
        };

        const exists = await validateUserPrefix(userPrefix);
        if (userPrefix.length == 4) {
          if (exists.responseCode == "0") {
            setSnackbarMessage("User Prefix already exist");
            setError("error");
            setSnackbarOpen(true);
            return;
          }
        } else {
          setSnackbarMessage("User Prefix length shoud be 4");
          setError("error");
          setSnackbarOpen(true);
          return;
        }

        const response = await addUser(userData);
        if (response && response?.isSuccess) {
          setUserID(response?.result);
          setSnackbarMessage("User created successfully.");
          setError("success");
          setSnackbarOpen(true);
        } else {
          setError("error");
          setSnackbarMessage(response?.message);
          setSnackbarOpen(true);
        }
      } catch (error) {
        setSnackbarMessage(
          "An error occurred while saving contact details. Please try again.",
        );
        setError("error");
        setSnackbarOpen(true);
        console.error("Error during API call:", error);
      } finally {
        setIsSaving(false);
      }
    }
  };
  useEffect(() => {
    if (userID) {
      setNewContactID(userID);
      setTimeout(() => {
        onBack();
      }, 1000);
    }
  }, [userID]);

  const [userDetailFormKey, setuserDetailFormKey] = useState<string | null>(
    "0",
  );

  const userdetailformAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
        title:
          userDetailFormKey === index.toString() ? (
            item.title
          ) : (
            <>{item.title}</>
          ),
      }))}
      activeKey={userDetailFormKey}
      onSelect={(key) => setuserDetailFormKey(key as string)}
    />
  );

  const [assignmentDetailKey, setassignmentDetailKey] = useState<string | null>(
    "0",
  );

  const assignmentdetailAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={assignmentDetailKey}
      onSelect={(key) => setassignmentDetailKey(key as string)}
    />
  );

  const handleCancel = () => {
    setSaluation(null);
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setUserName("");
    setPassword("");
    setGender(null);
    setEmailId("");
    setPhoneNumber("");
    setFaxNumber("");
    setCompanyID(null);
    setWebRoleID([]);
    setDepartmentID(null);
    setUserTypeID(null);
    setIsActive(true);
    setIsMFA(true);
  };
  const handleShortCodeValidation = async (prefix: string) => {
    if (prefix.length < 4) {
      setIsShortCodeValid(null); // no validation yet
      return;
    }
    try {
      const exists = await validateUserPrefix(prefix);
      if (exists.responseCode == "0") {
        setIsShortCodeValid(false);
        setSnackbarMessage("User Prefix already exist");
        setError("error");
        setSnackbarOpen(true);
      } else {
        setIsShortCodeValid(true); // ✅ available
      }
    } catch (error) {
      setError("Error validating short code.");
      setIsShortCodeValid(false);
    }
  };
  return (
    <>
      <Container fluid className="px-3 d-flex flex-column min-vh-95">
        <Snackbar
          open={snackbarOpen}
          message={snackbarMessage}
          onClose={() => setSnackbarOpen(false)}
          severity={error}
        />
        {userdetailformAccordion([
          {
            title: "User Details",
            content: (
              <>
                <Row>
                  <Col sm={3} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Saluation"
                      name="saluationId"
                      required
                      options={saluationOption}
                      value={saluation}
                      onChange={(e, name, value) => setSaluation(value)}
                    />
                  </Col>
                  <Col sm={3}>
                    <TextInput
                      label="First Name"
                      name="Firstname"
                      value={firstName}
                      onChange={async (e) => {
                        let onlyText = e.target.value.replace(/[^a-zA-Z]/g, "");

                        const firstTwo = onlyText.slice(0, 2);
                        const lastTwo = lastName?.slice(0, 2) || "";
                        const prefix = (firstTwo + lastTwo).toUpperCase();
                        setFirstName(onlyText);
                        setUserPrefix(prefix);
                        await handleShortCodeValidation(prefix);
                      }}
                      spacesTrim={true}
                      required={true}
                      maxLength={30}
                    />
                  </Col>
                  <Col sm={3}>
                    <TextInput
                      label="Middle Name"
                      name="middlename"
                      value={middleName}
                      maxLength={20}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^a-zA-Z ]/g, "");
                        // Prevent initial space
                        setMiddleName(value.trimStart());
                      }}
                      spacesTrim={true}
                    />
                  </Col>
                  <Col sm={3}>
                    <TextInput
                      label="Last Name"
                      name="Lastname"
                      value={lastName}
                      onChange={async (e) => {
                        let onlyText = e.target.value.replace(/[^a-zA-Z]/g, "");

                        const firstTwo = firstName?.slice(0, 2) || "";
                        const lastTwo = onlyText.slice(0, 2);
                        const prefix = (firstTwo + lastTwo).toUpperCase();
                        setUserPrefix(prefix);
                        setLastName(onlyText);
                        await handleShortCodeValidation(prefix);
                      }}
                      spacesTrim={true}
                      required={true}
                      maxLength={30}
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col sm={3}>
                    <TextInput
                      label="Username"
                      name="usernae"
                      value={userName}
                      maxLength={50}
                      required={true}
                      onChange={(e) => {
                        const value = e.target.value.replace(
                          /[^a-zA-Z0-9@._]/g,
                          "",
                        );

                        setUserName(value.trimStart());
                      }}
                      spacesTrim={true}
                    />
                  </Col>
                  {/* <Col sm={3}>
                    <TextInputTypeField
                      label="Password"
                      name="Password"
                      value={password}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^a-zA-Z ]/g, "");

                        setPassword(value.trimStart());
                      }}
                      required={true}
                      type="password"
                      maxLength={30}
                      spacesTrim={true}
                      disabled
                    />
                  </Col> */}
                  <Col xs={3}>
                    <div style={{ position: "relative" }}>
                      <TextInput
                        label="User Prefix"
                        name="ShortCode"
                        value={userPrefix}
                        required
                        maxLength={4}
                        onChange={async (e) => {
                          let onlyText = e.target.value
                            .replace(/[^a-zA-Z]/g, "")
                            .toUpperCase();
                          setUserPrefix(onlyText);
                          await handleShortCodeValidation(onlyText);
                        }}
                      />
                      {isShortCodeValid == true && (
                        <span className="material-symbols-outlined verfied_arrow">
                          verified
                        </span>
                      )}
                    </div>
                  </Col>
                  {/* <Col sm={3} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Gender"
                      name="genderId"
                      required
                      options={genderOption}
                      value={gender}
                      onChange={(e, name, value) => setGender(value)}
                    />
                  </Col> */}
                  <Col sm={3}>
                    <TextInput
                      label="Email ID"
                      name="Emailid"
                      value={emailId}
                      onChange={(e) => {
                        const trimmedValue = e.target.value.trimStart();
                        setEmailId(trimmedValue || "");
                      }}
                       onClick={() => {
    if (emailId.length > 0) {
      window.location.href = `mailto:${emailId[0]}`;
    }
  }}
                      required={true}
                      maxLength={100}
                    />
                  </Col>
                  <Col sm={3}>
                    <FormattedPhoneInput
                      label="Phone Number"
                      name="Phonenumber"
                      value={phoneNumber}
                      onChange={setPhoneNumber}
                      required={true}
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col sm={3}>
                    <FormattedPhoneInput
                      label="Fax No"
                      name="Faxnumber"
                      value={faxNumber}
                      onChange={setFaxNumber}
                    />
                  </Col>
                  <Col sm={3} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Currency"
                      value={selectedCurrency}
                      options={currencyOptions}
                      onChange={handleCurrencyChange}
                      name="currencyID"
                      required={true}
                    />
                  </Col>
                </Row>
              </>
            ),
          },
        ])}
        {assignmentdetailAccordion([
          {
            title: "Assignment Details",
            content: (
              <>
                <Row className="mt-1">
                  <Col sm={3} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Company ID"
                      name="Companyid"
                      options={companyIDOptions}
                      value={companyID}
                      onChange={(e, name, value) => setCompanyID(value)}
                      required={true}
                    />
                  </Col>
                  <Col sm={3} className="selection_dropdown">
                    <SearchableMultiSelectDropdown
                      label="Web Role"
                      name="Roleids"
                      options={processedWebRoleOptions}
                      values={webRoleID}
                      onChange={(e, name, value) => setWebRoleID(value)}
                      required={true}
                    />
                  </Col>
                  <Col sm={3} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Department"
                      name="department"
                      options={departmentOptions}
                      value={departmentID}
                      onChange={(e, name, value) => setDepartmentID(value)}
                      required={true}
                      disabled={webRoleID?.length == 0}
                    />
                  </Col>

                  <Col sm={3} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="User Type"
                      name="userType"
                      options={userTypeOptions}
                      value={userTypeID}
                      onChange={(e, name, value) => setUserTypeID(value)}
                      required={true}
                      disabled={webRoleID?.length == 0}
                    />
                  </Col>

                  <Col sm={3} className="mt-3">
                    <div className="form-check p-2 py-2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="Isactive"
                        name="Isactive"
                        checked={isActive}
                        onChange={(e) => setIsActive(e.target.checked)}
                        style={{ cursor: "pointer" }}
                      />
                      <label className="form-check-label">Is Active?</label>
                      <span style={{ color: "red" }}> *</span>
                    </div>
                  </Col>
                  <Col sm={3} className="mt-3">
                    <div className="form-check p-2 py-2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="IsMFA"
                        name="IsMFA"
                        checked={isMFA}
                        onChange={(e) => setIsMFA(e.target.checked)}
                        style={{ cursor: "pointer" }}
                      />
                      <label className="form-check-label">Is MFA?</label>
                      <span style={{ color: "red" }}> *</span>
                    </div>
                  </Col>
                </Row>
              </>
            ),
          },
        ])}

        <Row className="mt-3">
          <Col sm={12}>
            <div className="d-flex justify-content-end">
              <Button
                variant="outline-info"
                className="d-flex align-items-center"
                onClick={handleCancel}
              >
                <span className="material-icons me-2">close</span>Cancel
              </Button>
              <Button
                type="submit"
                variant="primary"
                className="ms-3 d-flex align-items-center"
                onClick={handleSave}
                disabled={isSaving}
              >
                <span className="material-icons me-1">save</span>Save
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddNewContactUser;
